import type {ReactElement} from 'react';
import {useState} from 'react';
import {Button, ButtonSize, ButtonType} from '@Components/button';
import {openGoogleMapSelectorModal} from '@Modals/google-map-selector-modal/google-map-selector-modal.types';
import type {GoogleMapsSelectorProps} from './google-maps-selector.types';
import {repoURL} from '@Libraries/s3-library';
import {getReadBucket} from '@Utils/s3.util';
import styles from './google-maps-selector.module.scss';

export function GoogleMapsSelector({
  googleMapAPIKey,
  onLocationChange,
  size = ButtonSize.SMALL,
  type = ButtonType.SECONDARY,
  text = window.i18next.t('pmwjs_map'),
  isMobile = false,
  isFixedSmallIconWidth = false,
  hideButtonText = false,
  ...buttonProps
}: GoogleMapsSelectorProps): ReactElement<any> {
  const [isMapLoading, setIsMapLoading] = useState<boolean>(false);

  const openGoogleMapSelector = (): void => {
    setIsMapLoading(true);
    openGoogleMapSelectorModal({
      googleMapAPIKey: googleMapAPIKey,
      onLocationChange: onLocationChange,
      selectedVenue: undefined,
      onLoaded: () => {
        setIsMapLoading(false);
      },
    });
  };

  const getCustomIconForGoogleMapsCTA = (): ReactElement<any> => {
    return (
      <img
        className={`${styles.googleMapIcon} ${isMobile ? styles.mobile : ''} ${isFixedSmallIconWidth ? styles.fixedSmallIconWidth : ''}`}
        src={repoURL('assets/social-icons/original/social-icon-google-maps.png', getReadBucket())}
        alt=""
        aria-hidden="true"
      />
    );
  };

  return (
    <Button
      isLoading={isMapLoading}
      onClick={openGoogleMapSelector}
      customClasses={buttonProps.customClasses}
      size={size}
      {...!hideButtonText && {text:text}}
      type={type}
      customIcon={getCustomIconForGoogleMapsCTA()}
    />
  );
}
